import { render } from "./AlpbachButton.vue?vue&type=template&id=592fe12e"
import script from "./AlpbachButton.vue?vue&type=script&lang=js"
export * from "./AlpbachButton.vue?vue&type=script&lang=js"

import "./AlpbachButton.vue?vue&type=style&index=0&id=592fe12e&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__